(function () {
  const DISMISS_KEY = 'sbKlaviyoDismissed';
  const AUTO_OPEN_DELAY_MS = 2000;
  const OPEN_EVENT_NAME = 'sb:klaviyo-overlay:open';

  const SELECTORS = {
    root: '[data-sb-klaviyo-overlay]',
    panel: '.sb-klaviyo-top-overlay__panel',
    close: '[data-sb-klaviyo-close]',
    backdrop: '[data-sb-klaviyo-backdrop]',
    trigger: '[data-sb-klaviyo-open]',
  };

  let root;
  let panel;
  let closeButton;
  let backdrop;
  let autoOpenTimer = null;
  let lastFocusedElement = null;

  function readDismissed() {
    try {
      return window.localStorage.getItem(DISMISS_KEY) === '1';
    } catch (_) {
      return false;
    }
  }

  function writeDismissed() {
    try {
      window.localStorage.setItem(DISMISS_KEY, '1');
    } catch (_) {
      // Ignore storage failures (private mode, blocked storage, etc.)
    }
  }

  function setAccessibilityState(isOpen) {
    if (!root || !panel || !backdrop) return;

    root.setAttribute('aria-hidden', String(!isOpen));
    panel.setAttribute('aria-hidden', String(!isOpen));
    backdrop.setAttribute('aria-hidden', String(!isOpen));

    if (isOpen) root.removeAttribute('inert');
    else root.setAttribute('inert', '');
  }

  function isOpen() {
    return !!root && root.classList.contains('is-open');
  }

  function openOverlay(options) {
    const { force = false } = options || {};
    if (!root || !panel || isOpen()) return;
    if (!force && readDismissed()) return;

    if (autoOpenTimer) {
      window.clearTimeout(autoOpenTimer);
      autoOpenTimer = null;
    }

    lastFocusedElement =
      document.activeElement instanceof HTMLElement ? document.activeElement : null;

    setAccessibilityState(true);
    root.classList.add('is-open');

    window.requestAnimationFrame(function () {
      if (!closeButton) return;
      try {
        closeButton.focus({ preventScroll: true });
      } catch (_) {
        closeButton.focus();
      }
    });
  }

  function closeOverlay() {
    if (!root) return;

    writeDismissed();

    if (autoOpenTimer) {
      window.clearTimeout(autoOpenTimer);
      autoOpenTimer = null;
    }

    if (!isOpen()) {
      setAccessibilityState(false);
      return;
    }

    root.classList.remove('is-open');
    setAccessibilityState(false);

    if (lastFocusedElement && document.contains(lastFocusedElement)) {
      try {
        lastFocusedElement.focus({ preventScroll: true });
      } catch (_) {
        lastFocusedElement.focus();
      }
    }
  }

  function onDocumentKeydown(event) {
    if (event.key !== 'Escape' || !isOpen()) return;
    event.preventDefault();
    closeOverlay();
  }

  function onDocumentClick(event) {
    const trigger = event.target.closest(SELECTORS.trigger);
    if (!trigger) return;

    event.preventDefault();
    openOverlay({ force: true });
  }

  function onOpenRequest() {
    openOverlay({ force: true });
  }

  function scheduleAutoOpen() {
    if (readDismissed()) return;

    autoOpenTimer = window.setTimeout(function () {
      autoOpenTimer = null;
      if (!readDismissed()) openOverlay();
    }, AUTO_OPEN_DELAY_MS);
  }

  function init() {
    root = document.querySelector(SELECTORS.root);
    if (!root || root.dataset.sbKlaviyoOverlayInit === 'true') return;

    panel = root.querySelector(SELECTORS.panel);
    closeButton = root.querySelector(SELECTORS.close);
    backdrop = root.querySelector(SELECTORS.backdrop);

    if (!panel || !closeButton || !backdrop) return;

    root.dataset.sbKlaviyoOverlayInit = 'true';
    setAccessibilityState(false);

    closeButton.addEventListener('click', closeOverlay);
    backdrop.addEventListener('click', closeOverlay);
    document.addEventListener('click', onDocumentClick);
    document.addEventListener(OPEN_EVENT_NAME, onOpenRequest);
    document.addEventListener('keydown', onDocumentKeydown);

    scheduleAutoOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
